import React, { useEffect, useState } from 'react';
import { Table, TableCell, TableHead, TableRow, makeStyles, TablePagination, TableSortLabel } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/FileCopy';

const useStyles = makeStyles(theme => ({
    table: {
        marginTop: theme.spacing(3),
        '& thead th': {
            fontWeight: '600',
            // color: 'white',
            // backgroundColor: '#000000',
            color: theme.palette.primary.main,
            backgroundColor: '#ffffff',
            border: 'solid 1px #c1bdbd',
            
        },
        '& tbody td': {
            fontWeight: '300',    
            border: 'solid 1px #c1bdbd',
        },
        '& tbody tr:hover': {
            backgroundColor: '#ffffff',
            cursor: 'pointer',
        },
    },
}));

export default function useTable(records, headCells, filterFn, searchChange = false, pageAfterSearch=false) {
    const classes = useStyles();
    const pages = [50, 100, 150, 200];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pages[page]);
    const [order, setOrder] = useState();
    const [orderBy, setOrderBy] = useState();

    useEffect(() => {
        if (pageAfterSearch) {
            setPage(0);
        } else {

        }
    }, [pageAfterSearch]);

    const TblContainer = props => (
        <Table className={classes.table}>
            {props.children}
        </Table>
    );

    const TblHead = props => {
        const handleSortRequest = (cellId) => {
            const isAsc = orderBy === cellId && order === "asc";
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(cellId);
        };

        const handleCopyRequest = (cellId) => {
            const columnData = recordsAfterPagingAndSorting()?.map(row => row[cellId]).join('\n');
            navigator.clipboard.writeText(columnData)
              .then(() => alert(`Copied ${cellId} column to clipboard!`))
              .catch((error) => console.error("Copy failed", error));
        };

        return (
            <TableHead>
                <TableRow>
                    {
                        headCells.map(headCell => (
                            <TableCell key={headCell.id} sortDirection={orderBy === headCell.id ? order : false}>
                                {headCell.disableSorting ? headCell.label :
                                    <TableSortLabel onClick={() => handleSortRequest(headCell.id)}
                                        direction={orderBy === headCell.id ? order : 'asc'} active={orderBy === headCell.id}>
                                        {headCell.label}
                                    </TableSortLabel>}

                                {headCell.isCopyEnable ? <div onClick={() => handleCopyRequest(headCell.id)} className="copyIcon">
                                    <HomeIcon style={{ float: 'right' }} />
                                </div> : ''}
                            </TableCell>
                        ))
                    }
                </TableRow>
            </TableHead>)
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const TblPagination = () => (
        <TablePagination labelRowsPerPage={"Page"} component="div" page={page} rowsPerPage={rowsPerPage} rowsPerPageOptions={pages}
            count={searchChange ? recordsAfterPagingAndSorting().length : records.length}
            onChangePage={handleChangePage} onChangeRowsPerPage={handleChangeRowPerPage} />
    );

    function stableSort(array, comparator) {
        const stablilizedThis = array.map((el, index) => [el, index]);
        stablilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0)
                return order;
            return a[1] - b[1];
        });

        return stablilizedThis.map((el) => el[0]);
    }

    function getComparator(order, orderBy) {
        return order === "desc"
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy)
    }

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }

        if (b[orderBy] > a[orderBy]) {
            return 1;
        }

        return 0;
    }

    const recordsAfterPagingAndSorting = () => {
        return stableSort(filterFn.fn(records), getComparator(order, orderBy)).slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    };

    return {
        TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting
    }
}
